module.exports = "/images/feature-6.png";